unit uFrmMain;

interface

uses
  System.SysUtils, Vcl.Forms, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls, WEBLib.Controls, WEBLib.ExtCtrls,
  Unit1, uReadTXT, Planta, uTransform, uLoadTXT, uGrafico,
  LoginFRM, uCards, uAgenda, uSubForm2, Produtos, uPreview,
  WEBLib.Buttons, Vcl.Imaging.pngimage, Vcl.Imaging.GIFImg, WEBLib.WebCtrls;

type
  TFrmMain = class(TForm)
    HostPanel: TPanel;
    LeftPanel: TPanel;
    btnLogin: TBitBtn;
    btnHome: TBitBtn;
    btnProdutos: TBitBtn;
    btnHistRead: TBitBtn;
    btnLogout: TBitBtn;
    btnAgenda: TBitBtn;
    btnTeste: TBitBtn;
    btnPlanta: TBitBtn;
    appcontent: THTMLDiv;
    loader: THTMLDiv;
    procedure btnProdutosClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure btnLoginClick(Sender: TObject);
    procedure btnHomeClick(Sender: TObject);
    procedure btnLogoutClick(Sender: TObject);
    procedure btnLoginMouseEnter(Sender: TObject);
    procedure btnLoginMouseLeave(Sender: TObject);
    procedure btnHomeMouseLeave(Sender: TObject);
    procedure btnHomeMouseEnter(Sender: TObject);
    procedure btnProdutosMouseEnter(Sender: TObject);
    procedure btnProdutosMouseLeave(Sender: TObject);
    procedure btnHistReadxxxMouseEnter(Sender: TObject);
    procedure btnHistReadxxxMouseLeave(Sender: TObject);
    procedure btnLogoutMouseEnter(Sender: TObject);
    procedure btnLogoutMouseLeave(Sender: TObject);
    procedure btnAgendaClick(Sender: TObject);
    [async] procedure btnTesteClick(Sender: TObject); async;
    procedure LeftPanelDblClick(Sender: TObject);
    procedure btnPlantaClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnHistReadClick(Sender: TObject);
  public
    frm: TForm;
    BaseURL: widestring;
    xIdUdV: integer;               //Identificador da Tabela ItensNF_Volumes
  protected procedure LoadDFMValues; override; end;

var
  FrmMain: TFrmMain;

implementation

{$R *.dfm}


procedure TFrmMain.btnLoginClick(Sender: TObject);
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TForm9.CreateNew(HostPanel.ElementID, nil);
end;

procedure TFrmMain.btnLoginMouseEnter(Sender: TObject);
begin
    if btnLogin.Enabled  then
    begin
      btnLogin.Color:= clYellow;
    end;
end;

procedure TFrmMain.btnLoginMouseLeave(Sender: TObject);
begin
      btnLogin.Color:= clPaleturquoise;
end;

procedure TFrmMain.btnHistReadxxxMouseEnter(Sender: TObject);
begin
    if btnHistRead.Enabled  then
    begin
      btnHistRead.Color:= clYellow;
    end;
end;

procedure TFrmMain.btnHistReadxxxMouseLeave(Sender: TObject);
begin
      btnHistRead.Color:= clPaleturquoise;
end;

procedure TFrmMain.btnProdutosClick(Sender: TObject);
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TuProdutos.CreateNew(HostPanel.ElementID, nil);
end;

procedure TFrmMain.btnHistReadClick(Sender: TObject);
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TLoadTXT.CreateNew(HostPanel.ElementID, nil);
  //frm :=  TLoadTXT.CreateNew(HostPanel.ElementID, nil);
end;

procedure TFrmMain.btnHomeClick(Sender: TObject);
begin
  // destroy possible old form
  if Assigned(frm) then
  begin
    frm.Close;
    frm := nil;
  end;
end;

procedure TFrmMain.btnHomeMouseEnter(Sender: TObject);
begin
    btnHome.Color:= clYellow;
end;

procedure TFrmMain.btnHomeMouseLeave(Sender: TObject);
begin
    btnHome.Color:= clBtnFace;
end;

procedure TFrmMain.btnLogoutClick(Sender: TObject);
begin
  // destroy possible old form
  if Assigned(frm) then
  begin
    frm.Close;
    frm := nil;
  end;

  //Volta ao estado inicial
  btnLogin.Enabled      := true;
  btnProdutos.Enabled   := false;
  btnHistRead.Enabled    := false;
  btnPlanta.Enabled     := false;
  btnAgenda.Enabled     := false;

  btnLogout.Enabled     := false;
end;

procedure TFrmMain.btnLogoutMouseEnter(Sender: TObject);
begin
    if btnLogout.Enabled  then
    begin
      btnLogout.Color:= clYellow;
    end;
end;

procedure TFrmMain.btnLogoutMouseLeave(Sender: TObject);
begin
      btnLogout.Color:= $00AC9AF5;
end;

procedure TFrmMain.btnProdutosMouseEnter(Sender: TObject);
begin
    if btnProdutos.Enabled  then
    begin
      btnProdutos.Color:= clYellow;
    end;
end;

procedure TFrmMain.btnProdutosMouseLeave(Sender: TObject);
begin
      btnProdutos.Color:= clPaleturquoise;
end;

procedure TFrmMain.LeftPanelDblClick(Sender: TObject);
begin
    btnTeste.Visible  := not btnTeste.Visible;
    btnAgenda.Visible := btnTeste.Visible;

    //Ampulheta Linear
    loader.Visible    := btnTeste.Visible;
end;

procedure TFrmMain.btnAgendaClick(Sender: TObject);
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TReadTXT.CreateNew(HostPanel.ElementID, nil);
end;

procedure TFrmMain.btnTesteClick(Sender: TObject);
var
  PView: TGrafico;
begin
  PView:= TGrafico.Create(Self);
  try
    PView.Popup:= True;
    PView.Border:= fbDialogSizeable;

    //Carrega HTML e CONTROLES
    Await(TGrafico, PView.Load());

    Await(TModalResult, PView.Execute);
  finally
    PView.Free;
  end;
end;

procedure TFrmMain.btnPlantaClick(Sender: TObject);
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TuPlanta.CreateNew(HostPanel.ElementID, nil);
end;

procedure TFrmMain.WebFormCreate(Sender: TObject);
begin
  frm := nil;
end;

procedure TFrmMain.WebFormShow(Sender: TObject);
begin
      BaseURL := 'http://40.117.230.207:8083/api/';
      //BaseURL := 'http://localhost:8083/api/';
end;

procedure TFrmMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  HostPanel := TPanel.Create(Self);
  LeftPanel := TPanel.Create(Self);
  btnLogin := TBitBtn.Create(Self);
  btnHome := TBitBtn.Create(Self);
  btnProdutos := TBitBtn.Create(Self);
  btnHistRead := TBitBtn.Create(Self);
  btnLogout := TBitBtn.Create(Self);
  btnAgenda := TBitBtn.Create(Self);
  btnTeste := TBitBtn.Create(Self);
  btnPlanta := TBitBtn.Create(Self);
  appcontent := THTMLDiv.Create('appcontent');
  loader := THTMLDiv.Create('loader');

  HostPanel.BeforeLoadDFMValues;
  LeftPanel.BeforeLoadDFMValues;
  btnLogin.BeforeLoadDFMValues;
  btnHome.BeforeLoadDFMValues;
  btnProdutos.BeforeLoadDFMValues;
  btnHistRead.BeforeLoadDFMValues;
  btnLogout.BeforeLoadDFMValues;
  btnAgenda.BeforeLoadDFMValues;
  btnTeste.BeforeLoadDFMValues;
  btnPlanta.BeforeLoadDFMValues;
  appcontent.BeforeLoadDFMValues;
  loader.BeforeLoadDFMValues;
  try
    Name := 'FrmMain';
    Width := 893;
    Height := 965;
    Align := alClient;
    Caption := 'EXITO';
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -13;
    Font.Name := 'Tahoma';
    Font.Style := [];
    FormContainer := 'appcontent';
    ParentFont := False;
    Visible := True;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    HostPanel.SetParentComponent(Self);
    HostPanel.Name := 'HostPanel';
    HostPanel.Left := 145;
    HostPanel.Top := 0;
    HostPanel.Width := 748;
    HostPanel.Height := 965;
    HostPanel.HeightPercent := 96.000000000000000000;
    HostPanel.Align := alClient;
    HostPanel.AutoSize := True;
    HostPanel.TabOrder := 0;
    LeftPanel.SetParentComponent(Self);
    LeftPanel.Name := 'LeftPanel';
    LeftPanel.Left := 0;
    LeftPanel.Top := 0;
    LeftPanel.Width := 145;
    LeftPanel.Height := 965;
    LeftPanel.Align := alLeft;
    LeftPanel.ChildOrder := 13;
    LeftPanel.Color := 13789440;
    LeftPanel.ElementFont := efCSS;
    LeftPanel.ShowCaption := False;
    LeftPanel.TabOrder := 1;
    SetEvent(LeftPanel, Self, 'OnDblClick', 'LeftPanelDblClick');
    btnLogin.SetParentComponent(LeftPanel);
    btnLogin.Name := 'btnLogin';
    btnLogin.Left := 3;
    btnLogin.Top := 50;
    btnLogin.Width := 136;
    btnLogin.Height := 25;
    btnLogin.Caption := 'Login';
    btnLogin.Color := clPaleturquoise;
    btnLogin.ElementClassName := 'btn btn-light';
    btnLogin.ElementFont := efCSS;
    btnLogin.Font.Charset := ANSI_CHARSET;
    btnLogin.Font.Color := clWindowText;
    btnLogin.Font.Height := -13;
    btnLogin.Font.Name := 'Roboto';
    btnLogin.Font.Style := [];
    btnLogin.Glyph.LoadFromFile('uFrmMain.LeftPanel.btnLogin.Glyph.png');
    btnLogin.HeightStyle := ssAuto;
    btnLogin.HeightPercent := 100.000000000000000000;
    btnLogin.ParentFont := False;
    btnLogin.TabOrder := 3;
    btnLogin.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogin, Self, 'OnClick', 'btnLoginClick');
    SetEvent(btnLogin, Self, 'OnMouseLeave', 'btnLoginMouseLeave');
    SetEvent(btnLogin, Self, 'OnMouseEnter', 'btnLoginMouseEnter');
    btnHome.SetParentComponent(LeftPanel);
    btnHome.Name := 'btnHome';
    btnHome.Left := 3;
    btnHome.Top := 10;
    btnHome.Width := 136;
    btnHome.Height := 25;
    btnHome.Caption := 'Home';
    btnHome.Color := clBtnFace;
    btnHome.ElementClassName := 'btn btn-light';
    btnHome.ElementFont := efCSS;
    btnHome.Font.Charset := ANSI_CHARSET;
    btnHome.Font.Color := clWindowText;
    btnHome.Font.Height := -13;
    btnHome.Font.Name := 'Roboto';
    btnHome.Font.Style := [];
    btnHome.Glyph.LoadFromFile('uFrmMain.LeftPanel.btnHome.Glyph.png');
    btnHome.HeightStyle := ssAuto;
    btnHome.HeightPercent := 100.000000000000000000;
    btnHome.ParentFont := False;
    btnHome.TabOrder := 2;
    btnHome.WidthPercent := 100.000000000000000000;
    SetEvent(btnHome, Self, 'OnClick', 'btnHomeClick');
    SetEvent(btnHome, Self, 'OnMouseLeave', 'btnHomeMouseLeave');
    SetEvent(btnHome, Self, 'OnMouseEnter', 'btnHomeMouseEnter');
    btnProdutos.SetParentComponent(LeftPanel);
    btnProdutos.Name := 'btnProdutos';
    btnProdutos.Left := 3;
    btnProdutos.Top := 90;
    btnProdutos.Width := 136;
    btnProdutos.Height := 25;
    btnProdutos.Caption := 'Produtos';
    btnProdutos.Color := clPaleturquoise;
    btnProdutos.ElementClassName := 'btn btn-light';
    btnProdutos.ElementFont := efCSS;
    btnProdutos.Enabled := False;
    btnProdutos.Font.Charset := ANSI_CHARSET;
    btnProdutos.Font.Color := clWindowText;
    btnProdutos.Font.Height := -13;
    btnProdutos.Font.Name := 'Roboto';
    btnProdutos.Font.Style := [];
    btnProdutos.Glyph.LoadFromFile('uFrmMain.LeftPanel.btnProdutos.Glyph.png');
    btnProdutos.HeightStyle := ssAuto;
    btnProdutos.HeightPercent := 100.000000000000000000;
    btnProdutos.ParentFont := False;
    btnProdutos.TabOrder := 3;
    btnProdutos.TabStop := True;
    btnProdutos.WidthPercent := 100.000000000000000000;
    SetEvent(btnProdutos, Self, 'OnClick', 'btnProdutosClick');
    SetEvent(btnProdutos, Self, 'OnMouseLeave', 'btnProdutosMouseLeave');
    SetEvent(btnProdutos, Self, 'OnMouseEnter', 'btnProdutosMouseEnter');
    btnHistRead.SetParentComponent(LeftPanel);
    btnHistRead.Name := 'btnHistRead';
    btnHistRead.Left := 3;
    btnHistRead.Top := 200;
    btnHistRead.Width := 136;
    btnHistRead.Height := 25;
    btnHistRead.Caption := 'Hist'#243'rico';
    btnHistRead.Color := clPaleturquoise;
    btnHistRead.ElementClassName := 'btn btn-light';
    btnHistRead.ElementFont := efCSS;
    btnHistRead.Enabled := False;
    btnHistRead.Font.Charset := ANSI_CHARSET;
    btnHistRead.Font.Color := clWindowText;
    btnHistRead.Font.Height := -13;
    btnHistRead.Font.Name := 'Roboto';
    btnHistRead.Font.Style := [];
    btnHistRead.Glyph.LoadFromFile('uFrmMain.LeftPanel.btnHistRead.Glyph.png');
    btnHistRead.HeightStyle := ssAuto;
    btnHistRead.HeightPercent := 100.000000000000000000;
    btnHistRead.ParentFont := False;
    btnHistRead.TabOrder := 3;
    btnHistRead.WidthPercent := 100.000000000000000000;
    SetEvent(btnHistRead, Self, 'OnClick', 'btnHistReadClick');
    btnLogout.SetParentComponent(LeftPanel);
    btnLogout.Name := 'btnLogout';
    btnLogout.Left := 3;
    btnLogout.Top := 240;
    btnLogout.Width := 136;
    btnLogout.Height := 25;
    btnLogout.Caption := 'Logout';
    btnLogout.Color := 14011386;
    btnLogout.ElementClassName := 'btn btn-light';
    btnLogout.ElementFont := efCSS;
    btnLogout.Enabled := False;
    btnLogout.Font.Charset := ANSI_CHARSET;
    btnLogout.Font.Color := clWindowText;
    btnLogout.Font.Height := -13;
    btnLogout.Font.Name := 'Roboto';
    btnLogout.Font.Style := [];
    btnLogout.Glyph.LoadFromFile('uFrmMain.LeftPanel.btnLogout.Glyph.png');
    btnLogout.HeightStyle := ssAuto;
    btnLogout.HeightPercent := 100.000000000000000000;
    btnLogout.ParentFont := False;
    btnLogout.TabOrder := 3;
    btnLogout.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogout, Self, 'OnClick', 'btnLogoutClick');
    SetEvent(btnLogout, Self, 'OnMouseLeave', 'btnLogoutMouseLeave');
    SetEvent(btnLogout, Self, 'OnMouseEnter', 'btnLogoutMouseEnter');
    btnAgenda.SetParentComponent(LeftPanel);
    btnAgenda.Name := 'btnAgenda';
    btnAgenda.Left := 3;
    btnAgenda.Top := 394;
    btnAgenda.Width := 136;
    btnAgenda.Height := 25;
    btnAgenda.Caption := 'Leitura arquivo';
    btnAgenda.Color := clPaleturquoise;
    btnAgenda.ElementClassName := 'btn btn-light';
    btnAgenda.ElementFont := efCSS;
    btnAgenda.Enabled := False;
    btnAgenda.Font.Charset := ANSI_CHARSET;
    btnAgenda.Font.Color := clWindowText;
    btnAgenda.Font.Height := -13;
    btnAgenda.Font.Name := 'Roboto';
    btnAgenda.Font.Style := [];
    btnAgenda.Glyph.LoadFromFile('uFrmMain.LeftPanel.btnAgenda.Glyph.png');
    btnAgenda.HeightStyle := ssAuto;
    btnAgenda.HeightPercent := 100.000000000000000000;
    btnAgenda.ParentFont := False;
    btnAgenda.TabOrder := 3;
    btnAgenda.Visible := False;
    btnAgenda.WidthPercent := 100.000000000000000000;
    SetEvent(btnAgenda, Self, 'OnClick', 'btnAgendaClick');
    btnTeste.SetParentComponent(LeftPanel);
    btnTeste.Name := 'btnTeste';
    btnTeste.Left := 3;
    btnTeste.Top := 363;
    btnTeste.Width := 136;
    btnTeste.Height := 25;
    btnTeste.Caption := 'Preview';
    btnTeste.Color := clPaleturquoise;
    btnTeste.ElementClassName := 'btn btn-light';
    btnTeste.ElementFont := efCSS;
    btnTeste.Font.Charset := ANSI_CHARSET;
    btnTeste.Font.Color := clWindowText;
    btnTeste.Font.Height := -13;
    btnTeste.Font.Name := 'Roboto';
    btnTeste.Font.Style := [];
    btnTeste.Glyph.LoadFromFile('uFrmMain.LeftPanel.btnTeste.Glyph.png');
    btnTeste.HeightStyle := ssAuto;
    btnTeste.HeightPercent := 100.000000000000000000;
    btnTeste.ParentFont := False;
    btnTeste.TabOrder := 3;
    btnTeste.Visible := False;
    btnTeste.WidthPercent := 100.000000000000000000;
    SetEvent(btnTeste, Self, 'OnClick', 'btnTesteClick');
    btnPlanta.SetParentComponent(LeftPanel);
    btnPlanta.Name := 'btnPlanta';
    btnPlanta.Left := 3;
    btnPlanta.Top := 130;
    btnPlanta.Width := 136;
    btnPlanta.Height := 25;
    btnPlanta.Caption := 'Empresa';
    btnPlanta.Color := clPaleturquoise;
    btnPlanta.ElementClassName := 'btn btn-light';
    btnPlanta.ElementFont := efCSS;
    btnPlanta.Enabled := False;
    btnPlanta.Font.Charset := ANSI_CHARSET;
    btnPlanta.Font.Color := clWindowText;
    btnPlanta.Font.Height := -13;
    btnPlanta.Font.Name := 'Roboto';
    btnPlanta.Font.Style := [];
    btnPlanta.Glyph.LoadFromFile('uFrmMain.LeftPanel.btnPlanta.Glyph.png');
    btnPlanta.HeightStyle := ssAuto;
    btnPlanta.HeightPercent := 100.000000000000000000;
    btnPlanta.ParentFont := False;
    btnPlanta.TabOrder := 3;
    btnPlanta.WidthPercent := 100.000000000000000000;
    SetEvent(btnPlanta, Self, 'OnClick', 'btnPlantaClick');
    SetEvent(btnPlanta, Self, 'OnMouseLeave', 'btnHistReadxxxMouseLeave');
    SetEvent(btnPlanta, Self, 'OnMouseEnter', 'btnHistReadxxxMouseEnter');
    appcontent.SetParentComponent(Self);
    appcontent.Name := 'appcontent';
    appcontent.Left := 422;
    appcontent.Top := 25;
    appcontent.Width := 96;
    appcontent.Height := 25;
    appcontent.HeightStyle := ssAuto;
    appcontent.WidthStyle := ssAuto;
    appcontent.ChildOrder := 3;
    appcontent.ElementPosition := epIgnore;
    appcontent.ElementFont := efCSS;
    appcontent.Role := '';
    loader.SetParentComponent(Self);
    loader.Name := 'loader';
    loader.Left := 320;
    loader.Top := 25;
    loader.Width := 96;
    loader.Height := 25;
    loader.HeightStyle := ssAuto;
    loader.WidthStyle := ssAuto;
    loader.ChildOrder := 3;
    loader.ElementPosition := epIgnore;
    loader.ElementFont := efCSS;
    loader.Role := '';
    loader.Visible := False;
  finally
    HostPanel.AfterLoadDFMValues;
    LeftPanel.AfterLoadDFMValues;
    btnLogin.AfterLoadDFMValues;
    btnHome.AfterLoadDFMValues;
    btnProdutos.AfterLoadDFMValues;
    btnHistRead.AfterLoadDFMValues;
    btnLogout.AfterLoadDFMValues;
    btnAgenda.AfterLoadDFMValues;
    btnTeste.AfterLoadDFMValues;
    btnPlanta.AfterLoadDFMValues;
    appcontent.AfterLoadDFMValues;
    loader.AfterLoadDFMValues;
  end;
end;

end.
